import React from 'react';
import styled from 'styled-components';
import { Alert } from '../';
import { colors } from '../../variables';
import informationIcon from '../../../images/information.svg';

const Container = styled.div`
	position: relative;
	display: inline-block;
`;

const Button = styled.button`
	width: 24px;
	height: 24px;
	background: ${colors.blue.brommaDarker};
	border: 0;
	border-radius: 0;
	cursor: pointer;
	font-size: 10px;

	&:hover,
	&:focus {
		background: ${colors.blue.brommaLight};
	}
`;

const IconImage = styled.img`
	height: 14px;
	width: auto;
	margin-top: 3px;
`;

const Text = styled.p`
	margin: 0;
	padding: 0;
	padding-right: 20px;
	color: #fff;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.4;
`;

class Tooltip extends React.Component {
	state = {
		visible: false,
	};

	toggle = () => {
		this.setState(state => ({
			visible: !state.visible,
		}));
	};

	render() {
		const { className, children, wrapText = true } = this.props;

		return (
			<Container className={className}>
				<Button type="button" onClick={() => this.toggle()} title="Information">
					<IconImage src={informationIcon} alt="Information" />
				</Button>

				{this.state.visible && (
					<Alert
						fixed
						blue
						information
						icon="true"
						close={this.toggle}
						width={this.props.width ? this.props.width : null}
					>
						{wrapText ? <Text>{children}</Text> : <div>{children}</div>}
					</Alert>
				)}
			</Container>
		);
	}
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Common/Tooltip/Tooltip.js